export default '4.70.0';
